<template>
  <div v-bind:style="{
    'padding-bottom': (!$vuetify.breakpoint.mdAndUp && (detailView))
    ? '56px'
    : 'initial',
  }">
    <list-navigator
      v-if="detailView"
      class="mx-md-5 mx-lg-10 mx-xl-10 maxw-1750"
      :backButtonHref="`/soluciones/${ resourceCi }/`"
      :disabled="detailViewData.loading"
      :total="listViewData.items.length"
      :current="currentItemIndex"
      @navigate="(idx) => viewItemDetails(idx)"
      @share="handleShare"
      :isKI=true
    />

    <router-view v-on:request="request" v-bind="viewData" />

    <ShareDialog
      :visible="shareDialogOpen"
      @input="shareDialogOpen = false"
      :item="sharedItem"
      :positionX="sharedDialogPosition.positionX"
      :positionY="sharedDialogPosition.positionY"
    />

  </div>
</template>

<script>
import { ListNavigator, ShareDialog } from '@/components';
import KnowledgeItemsListView from './KnowledgeItemsListView.vue';
import KnowledgeItemsDetailView from './KnowledgeItemsDetailView.vue';

export {
  KnowledgeItemsListView,
  KnowledgeItemsDetailView,
  ShareDialog,
};

export default {
  props: {
    publicView: {
      type: Boolean,
      default: () => true,
    },
  },
  components: { ListNavigator, ShareDialog },
  data() {
    return {
      listViewData: {
        lastSearchArgs: {},
        items: [],
        listType: null,
        loading: false,
        typeKis: 'faqsItems',
      },
      detailViewData: {
        item: null,
        backButton: false,
        loading: false,
      },
      currentView: null,
      transitionName: null,
      resourceCi: '',
      sharedDialogPosition: {},
      shareDialogOpen: false,
    };
  },
  computed: {
    listView() {
      return this.currentView === 'list';
    },
    detailView() {
      return this.currentView === 'detail';
    },
    currentItemIndex() {
      const currentItem = this.detailViewData.item;
      if (currentItem == null) {
        return -1;
      }
      return this.listViewData.items.findIndex((item) => item.id === currentItem.id);
    },
    viewData() {
      let data = {};
      if (this.listView) {
        data = this.listViewData;
      } else if (this.detailView) {
        data = this.detailViewData;
      }
      return data;
    },
    sharedItem() {
      const { item } = this.detailViewData;
      if (item == null) return null;
      return {
        text: `${this.$t('components.share.subjectBody.knowledge')} ${item.name}`,
        url: `${process.env.VUE_APP_EXTERNAL_URL}${process.env.VUE_APP_BASE_URL_MICS_SSPA}knowledge-items/${item.id}`,
        formName: item.name,
        type: 'KI',
      };
    },
  },
  methods: {
    async searchKnowledgeItems({ filters, page }) {
      const data = this.listViewData;

      data.loading = true;
      try {
        const { lastSearchArgs } = data;

        // we will make the request if filters have changed
        const mustRequest = JSON.stringify(lastSearchArgs.filters) !== JSON.stringify(filters);

        if (mustRequest) {
          if (page === 0) {
            data.items = [];
          }

          // generic search request
          const { text } = (filters || {});
          const response = await this.client.listFaqs(
            {
              search: text,
              resourceCi: this.resourceCi,
            },
          );

          data.items = response.list;
          data.lastSearchArgs = { filters: { text }, page, total: response.total };
        }
      } catch (ex) {
        console.error('error getting faqs items page (filters=', filters, ')', ex);
      }
      this.detailViewData.backButton = data.items.length > 0;
      data.loading = false;
    },
    viewItemDetails(index) {
      const item = this.listViewData.items[index];
      this.getKnowledgeItemDetail({ id: item.id });
      this.$router.push(`/soluciones/${ this.resourceCi }/${item.id}`);
    },
    async getKnowledgeItemDetail({ id }) {
      console.log('getting faqs item detail with id ', id);

      const data = this.detailViewData;
      const currentList = this.listViewData.items;

      try {
        data.loading = true;

        const cachedItem = currentList.find((item) => {
          const sameId = item.id === id;
          // eslint-disable-next-line no-underscore-dangle
          const hasBeenCached = item.__$cached__ === true;
          if (sameId) {
            console.log('found item with id ', id, ' which has been cached', hasBeenCached);
          }
          return sameId && hasBeenCached;
        });

        if (cachedItem != null) {
          data.item = cachedItem;
        } else if (data.item == null || data.item.id !== id) {
          const baseUrl = this.$router.options.base;
          const req = this.client.getDetail(id, baseUrl, false);
          const response = await req;
          data.item = req.format(response).unique();

          const listIndex = currentList.findIndex((item) => item.id === data.item.id);
          if (listIndex !== -1) {
            currentList[listIndex] = data.item;
            // eslint-disable-next-line no-underscore-dangle
            currentList[listIndex].__$cached__ = true;
          }

          if (this.$store.getters['session/isSignedIn']) {
            this.client.hit(id) // increment item hits async (only for signed in users)
              .then((newHits) => {
                if (listIndex !== -1) {
                  currentList[listIndex].hits = newHits;
                } else {
                  this.detailViewData.item.hits = newHits;
                }
              }, (err) => {
                console.error('error increasing item hits', err);
              });
          }
        }
      } catch (ex) {
        // TODO map error in details view
        console.error('error loading ticket details info', ex);
      }
      data.loading = false;
    },
    request({ type, args }) {
      this.currentView = type;
      switch (type) {
      case 'list':
        this.searchKnowledgeItems(args);
        break;
      case 'detail':
        this.getKnowledgeItemDetail(args);
        break;
      default: console.warn(`some KnowledgeItemView children requested unmapped data (${type})`);
      }
    },
    handleShare() {
      const { item } = this.detailViewData;
      if (item == null) return;

      const isMobile = this.$store.getters['globalState/get']('deviceOS') != null;

      if (isMobile === true && window.flutter_inappwebview) {
        const fullShareUrl = `${process.env.VUE_APP_EXTERNAL_URL}${process.env.VUE_APP_BASE_URL_MICS_SSPA}knowledge-items/${item.id}`;
        const args = {
          name: this.$t('components.share.mobile.knowledgeItems'),
          url: fullShareUrl,
          formName: item.name,
          type: 'KI',
        };
        window.flutter_inappwebview.callHandler('shareDataUsingNative', args);
        return;
      }

      this.shareDialogOpen = true;
    },
  },
  created() {
    const path = window.location.pathname.split('/');
    this.resourceCi = [...path].pop();
    this.client = this.$api.getClient('knowledgeItems');
  },
};
</script>
